import { Close, Lock, LockOpen, Shield } from '@mui/icons-material';
import { Box, Card, Grid2, Typography } from '@mui/material';
import ButtonComponent from 'components/ButtonComponent';
import { AppContext } from 'context/AppContextProvider';
import { useContext, useState } from 'react';
import {
  useArmPartialVirtualAlarmCentral,
  useDeletePartition,
  useDisarmPartialVirtualAlarmCentral,
} from 'services/AlarmCentralService/Virtual/hooks/useMutation';
import { IPartitionProps } from 'services/AlarmCentralService/Virtual/types';
import ConfirmDeleteModalComponent from '../../../../../components/ConfirmDeleteModalComponent';
import VirtualCentralDeviceManagementModal from './VirtualAlarmCentralDeviceManagementModal';
import AlarmCentralPartitionCard from '../../_components/AlarmCentralPartitionCard';

interface VirtualAlarmCentralPartitionsProps {
  partitions: IPartitionProps[];
  onDeletePartition: () => void;
  alarmCentralId: number;
  onArmOrDisarmPartition: () => void;
}

const VirtualAlarmCentralPartitions = ({
  partitions,
  onDeletePartition,
  onArmOrDisarmPartition,
  alarmCentralId,
}: VirtualAlarmCentralPartitionsProps) => {
  const [isOpenDeletePartitionsModal, setIsOpenDeletePartitionsModal] =
    useState(false);
  const { showSnackbar } = useContext(AppContext);
  const [partitionToDelete, setPartitionToDelete] = useState<IPartitionProps>();
  const [partitionIdSelectedToEdit, setPartitionIdSelectedToEdit] =
    useState<number>();
  const [
    isOpenAlarmCentralDeviceManagementModal,
    setIsOpenAlarmCentralDeviceManagementModal,
  ] = useState(false);
  const { mutateAsync: mutateDeletePartition, isLoading } =
    useDeletePartition();
  const {
    mutateAsync: mutateArmPartialVirtualAlarmCentral,
    isLoading: isLoadingArmPartialVirtualAlarmCentral,
  } = useArmPartialVirtualAlarmCentral();
  const {
    mutateAsync: mutateDisarmPartialVirtualAlarmCentral,
    isLoading: isLoadingDisarmPartialVirtualAlarmCentral,
  } = useDisarmPartialVirtualAlarmCentral();

  const handleConfirmDeletion = () => {
    if (partitionToDelete)
      mutateDeletePartition(partitionToDelete.id).then(() => {
        onDeletePartition();
        setIsOpenDeletePartitionsModal(false);
        showSnackbar('Partição excluída com sucesso.', 'success');
      });
  };

  const armOrDisarmPartition = async (isArm: boolean, partitionId: number) => {
    if (isArm) {
      await mutateArmPartialVirtualAlarmCentral(
        {
          id: alarmCentralId,
          partitionId,
        },
        {
          onSuccess: () => {
            showSnackbar('Central armada com sucesso.', 'success');
          },
        },
      );
    } else
      await mutateDisarmPartialVirtualAlarmCentral(
        {
          id: alarmCentralId,
          partitionId,
        },
        {
          onSuccess: () => {
            showSnackbar('Central desarmada com sucesso.', 'success');
          },
        },
      );
    onArmOrDisarmPartition();
  };

  return (
    <Grid2
      container
      columnSpacing={1}
      rowSpacing={1}
      sx={{ overflowY: 'scroll', maxHeight: '300px', pr: 2 }}
    >
      {partitions
        .filter((p) => p.code != 0)
        .map((p) => {
          return (
            <Grid2 size={{ md: 6, xs: 12 }} key={p.code}>
              <AlarmCentralPartitionCard
                onDeletePartition={() => {
                  setPartitionToDelete(p);
                  setIsOpenDeletePartitionsModal(true);
                }}
                name={p.name}
                isVirtual
                isArmed={p.isArmed}
                account={p.account}
                onCheckDevices={() => {
                  setPartitionIdSelectedToEdit(p.id);
                  setIsOpenAlarmCentralDeviceManagementModal(true);
                }}
                isLoadingArmOrDisarm={
                  isLoadingArmPartialVirtualAlarmCentral ||
                  isLoadingDisarmPartialVirtualAlarmCentral
                }
                onArmOrDisarm={() => armOrDisarmPartition(!p.isArmed, p.id)}
              />
            </Grid2>
          );
        })}
      {partitionToDelete && (
        <ConfirmDeleteModalComponent
          setIsVisibleDeleteDialog={setIsOpenDeletePartitionsModal}
          isVisibleDeleteDialog={isOpenDeletePartitionsModal}
          handleCancelDeletion={() => {
            setPartitionToDelete(undefined);
            setIsOpenDeletePartitionsModal(false);
          }}
          isLoading={isLoading}
          message={`Tem certeza que deseja remover esta partição? (${partitionToDelete?.name})`}
          title="Exclusão"
          handleConfirmDeletion={handleConfirmDeletion}
        />
      )}

      <VirtualCentralDeviceManagementModal
        partitions={partitions}
        partitionIdSelectedToEdit={partitionIdSelectedToEdit}
        isOpen={isOpenAlarmCentralDeviceManagementModal}
        onClose={() => setIsOpenAlarmCentralDeviceManagementModal(false)}
      />
    </Grid2>
  );
};

export default VirtualAlarmCentralPartitions;
